// 车辆管理
export default [
  {
    name: 'oilCardManagement',
    path: '/carManagement/oilCardManagement',
    component: () => import('@/views/carManagement/oilCardManagement/index.vue'),
    meta: {
      title: '油卡管理'
    }
  },
  {
    name: 'carList',
    path: '/carManagement/carList',
    component: () => import('@/views/carManagement/carList/index.vue'),
    meta: {
      title: '车辆管理'
    }
  },
  {
    name: 'carRepairList',
    path: '/carManagement/carRepairList',
    component: () => import('@/views/carManagement/carRepairList/index.vue'),
    meta: {
      title: '维修记录'
    }
  },
  {
    name: 'carRefuelList',
    path: '/carManagement/carRefuelList',
    component: () => import('@/views/carManagement/carRefuelList/index.vue'),
    meta: {
      title: '加油记录'
    }
  },
  // {
  //   name: 'dormEmployeeFeeList',
  //   path: '/carManagement/dormEmployeeFeeList',
  //   component: () => import('@/views/carManagement/dormEmployeeFeeList/index.vue'),
  //   meta: {
  //     title: '住宿人员水电费明细'
  //   }
  // },
  // {
  //   name: 'dormRoomFeeList',
  //   path: '/carManagement/dormRoomFeeList',
  //   component: () => import('@/views/carManagement/dormRoomFeeList/index.vue'),
  //   meta: {
  //     title: '住宿房间水电费明细'
  //   }
  // },
  // {
  //   name: 'employeeRoomCountList',
  //   path: '/carManagement/employeeRoomCountList',
  //   component: () => import('@/views/carManagement/employeeRoomCountList/index.vue'),
  //   meta: {
  //     title: '人员宿舍统计报表'
  //   }
  // },
  // {
  //   name: 'dormPropertyManagement',
  //   path: '/carManagement/dormPropertyManagement',
  //   component: () => import('@/views/carManagement/dormPropertyManagement/index.vue'),
  //   meta: {
  //     title: '宿舍楼盘管理'
  //   }
  // },
  // {
  //   name: 'dormCheckInManagement',
  //   path: '/carManagement/dormCheckInManagement',
  //   component: () => import('@/views/carManagement/dormCheckInManagement/index.vue'),
  //   meta: {
  //     title: '入住手续管理'
  //   }
  // },
  // {
  //   name: 'dormChangeRoomManagement',
  //   path: '/carManagement/dormChangeRoomManagement',
  //   component: () => import('@/views/carManagement/dormChangeRoomManagement/index.vue'),
  //   meta: {
  //     title: '换房手续管理'
  //   }
  // },
  // {
  //   name: 'dormCheckOutManagement',
  //   path: '/carManagement/dormCheckOutManagement',
  //   component: () => import('@/views/carManagement/dormCheckOutManagement/index.vue'),
  //   meta: {
  //     title: '退房手续管理'
  //   }
  // },
  // {
  //   name: 'dormRoomResource',
  //   path: '/carManagement/dormRoomResource',
  //   component: () => import('@/views/carManagement/dormRoomResource/index.vue'),
  //   meta: {
  //     title: '房间资源'
  //   }
  // },
  // {
  //   name: 'dormFeeManagement',
  //   path: '/carManagement/dormFeeManagement',
  //   component: () => import('@/views/carManagement/dormFeeManagement/index.vue'),
  //   meta: {
  //     title: '水电费管理'
  //   }
  // },
  // {
  //   name: 'dormElectricFee',
  //   path: '/carManagement/dormElectricFee',
  //   component: () => import('@/views/carManagement/dormFeeManagement/dormElectricFee.vue'),
  //   meta: {
  //     title: '月度电费维护',
  //     parentAuth: '/carManagement/dormFeeManagement'
  //   },
  //   props: () => ({})
  // },
  // {
  //   name: 'dormWaterFee',
  //   path: '/carManagement/dormWaterFee',
  //   component: () => import('@/views/carManagement/dormFeeManagement/dormWaterFee.vue'),
  //   meta: {
  //     title: '月度水费维护',
  //     parentAuth: '/carManagement/dormFeeManagement'
  //   },
  //   props: () => ({ })
  // },
]
